<section class="form-flow">
  <section class="mx-auto pr-16 pl-16 pt-40 pb-32 lg-pt-0 max-w-600">
    <section class="back-link">
      <i class="fa-light fa-arrow-left mr-8"></i>

      <a [routerLink]="vm.mmrPageLink" class="button-text"
        >Back to the repairs page</a
      >
    </section>
    @if (vm.isLoading) {
    <app-skeleton-loader class="fill mt-40 h-32"> </app-skeleton-loader>
    <app-skeleton-loader class="fill mt-12 max-w-320 h-32">
    </app-skeleton-loader>

    <app-skeleton-loader class="fill mt-20" />

    <app-skeleton-loader class="mt-20 fill p-16">
      <app-skeleton-loader class="fill max-w-240 h-28" />
      <app-skeleton-loader class="fill mt-12" />

      <section class="flex full-width gap-12" style="flex: 1">
        <app-skeleton-loader class="mt-20 h-60" style="flex: 1" />
        <app-skeleton-loader class="mt-20 h-60" style="flex: 1" />
      </section>

      <section
        class="flex full-width gap-12"
        style="flex: 1; justify-content: space-between"
      >
        <app-skeleton-loader class="mt-20 h-52 max-w-160" style="flex: 1" />
        <app-skeleton-loader class="mt-20 h-52 max-w-160" style="flex: 1" />
      </section>
    </app-skeleton-loader>
    } @else {

    <div class="title-section">
      <h1 class="heading-1 mt-24 lg-mt-16">
        Let’s get your {{ vm.titleDetails }} running
      </h1>

      <dg-app-simple-progress-bar [percentage]="vm.percentage" />
    </div>
    <section class="card p-24 mt-32 lg-mt-24">
      <ng-container *ngIf="vm.loadingData">
        <app-skeleton-loader class="fill mt-40 h-32"> </app-skeleton-loader>
        <app-skeleton-loader class="fill mt-12 max-w-320 h-32">
        </app-skeleton-loader>

        <app-skeleton-loader class="fill mt-20" />

        <app-skeleton-loader class="mt-20 fill p-16">
          <app-skeleton-loader class="fill max-w-240 h-28" />
          <app-skeleton-loader class="fill mt-12" />

          <section class="flex full-width gap-12" style="flex: 1">
            <app-skeleton-loader class="mt-20 h-60" style="flex: 1" />
            <app-skeleton-loader class="mt-20 h-60" style="flex: 1" />
          </section>

          <section
            class="flex full-width gap-12"
            style="flex: 1; justify-content: space-between"
          >
            <app-skeleton-loader class="mt-20 h-52 max-w-160" style="flex: 1" />
            <app-skeleton-loader class="mt-20 h-52 max-w-160" style="flex: 1" />
          </section>
        </app-skeleton-loader>
      </ng-container>
      <ng-container *ngIf="!vm.loadingData">
        <router-outlet></router-outlet>
      </ng-container>

      <div>
        <div class="divider"></div>
      </div>
      <section class="actions">
        <app-button
          (onClick)="nextPage()"
          dataLabel="continue-button"
          [buttonOptions]="{
              type: 'submit',
              disabled: vm.loadingData,
            }"
          class="min-w-160"
        >
          {{ continueTitle }}
          <i class="fa-light fa-arrow-right ml-8"></i>
        </app-button>
        <app-button
          dataLabel="back-button"
          class="min-w-160"
          [buttonOptions]="{
              variant: 'secondary',
            }"
        >
          <i class="fa-light fa-arrow-left mr-8"></i>
          Back
        </app-button>
      </section>
    </section>
    }
  </section>
</section>
